/*External dependencies*/
import update from 'immutability-helper';
import { AuthActions, AuthActionTypes } from '../../../../auth/redux/action';
import { ListUsersActions, ListUsersActionsType } from './actions';

interface ListUsersStateType {
  isListUsersModalOpen: boolean;
  isLoading: boolean;
  usersAll: object;
}

export const initialState: ListUsersStateType = {
  isListUsersModalOpen: false,
  isLoading: false,
  usersAll: {},
};

export function listUsersReducer( state = initialState, action: ListUsersActionsType | AuthActions ) {
  switch ( action.type ) {
    case ListUsersActions.TOGGLE_LIST_USERS_MODAL_STATE:
      return update( state, {
        isListUsersModalOpen: { $set: !state.isListUsersModalOpen },
      } );
    case ListUsersActions.LIST_USERS_REQUEST:
      return update( state, {
        isLoading: { $set: true },
      } );
    case ListUsersActions.LIST_USERS_SUCCEEDED:
      return update( state, {
        usersAll: { $set: action.payload },
        isLoading: { $set: false },
      } );
    case ListUsersActions.LIST_USERS_FAILED:
      return update( state, {
        isLoading: { $set: false },
      } );
    case AuthActionTypes.SIGN_OUT_SUCCEEDED:
      return initialState
    default:
      return state;
  }
}
